import moment from 'moment';
import { useEffect, useRef, useState, useMemo } from 'react';
import { BiChevronDown, BiTransfer } from 'react-icons/bi';
import { BsHeadset } from 'react-icons/bs';
import { IoAlertOutline } from 'react-icons/io5';
import { toast } from 'react-toastify';
import {
  HistoricClient,
  Menu,
  Modal,
  NoteClient,
  ProfileClient,
  TransferClient,
  ViewerCustomerServiceOpen,
  VideoCallStatus
} from '../../../../../../../../components';
import { useChat } from '../../../../../../../../contexts/chat';
import { useOutsideAlerter } from '../../../../../../../../hooks';
import { maskDate, maskZero } from '../../../../../../../../utils';
import { Container, Content, Date, IconDown, Line, Loading, Name, Tag } from './styled';



export function Card(props) {

  const refMenu = useRef();

  const { data, active, loadChats, onSelectedCustomer, selectedCustomer } = props;
  const { handOpenPreview, onTransferCustomerByMy } = useChat();

  const [openHistoric, setOpenHistoric] = useState(false);
  const [transferOpen, setTransferOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [noteOpen, setNoteOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customerServiceOpenData, setCustomerServiceOpenData] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isSelected, setIsSelected] = useState(false);
  useOutsideAlerter(refMenu, handleCloseMenu);

  useEffect(() => {
    if (selectedCustomer?.customerServicersID?.includes(data.id)) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [selectedCustomer, data.id]);

  const titleTransfer = () => {
    return (
      <div style={{ maxWidth: "25rem" }}>
        Transferir
        <span style={{ fontWeight: "bolder", padding: '0 0.5rem 0 0.5rem' }}>
          {data.client_name}
        </span>
        para :
      </div>
    );
  }

  function handleOpenMenu(e) {
    setAnchorEl(e?.currentTarget)
  };

  function handleCloseMenu() {
    setAnchorEl(null);
  };

  function handleOpenNote() {
    setNoteOpen(true);
  }
  function handleCloseNote() {
    setNoteOpen(false);
  }

  function handleOpenTransfer() {
    handleCloseMenu();
    setTransferOpen(true);
  }
  function handleCloseTransfer() {
    setTransferOpen(false);
  }

  function handleOpenProfile() {
    handleCloseMenu();
    setProfileOpen(true);
  }
  function handleCloseProfile() {
    setProfileOpen(false);
  }

  function handleOpenHistoric() {
    handleCloseMenu();
    setOpenHistoric(true)
  };

  const handSelectedCustomer = () => {
    if (selectedCustomer?.isOpen) {
      onSelectedCustomer(data.id);
    }
  };


  const msgCustomerServiceOpen = (data) => {
    return (
      <div>
        <p>
          {`Já existe atendimento em aberto ! `}
        </p>
        <u
          onClick={
            () => setCustomerServiceOpenData(data)
          }
        >
          {`ver atendimento`}
        </u>
      </div>
    )
  };


  async function handTransferCustomerByMy() {
    setLoading(true);
    const response = await onTransferCustomerByMy(data, false, false);
    if (response === 'error') {
      setLoading(false)
      toast.error('Lamentamos, mas não foi possível iniciar o atendimento. ', { position: "top-right", theme: "colored" });
      return
    }
    if (response?.status === 'clone') {
      toast.warn(
        msgCustomerServiceOpen(response?.customerServiceOpen),
        { position: "top-center", theme: "colored" }
      );
      return setLoading(false)
    }
    setLoading(false);
  }

  function handOpenChat(e) {
    if (!selectedCustomer?.isOpen) {
      if (e.shiftKey) {
        return handTransferCustomerByMy();
      }
      handOpenPreview(data, data.client_name, 4);
    }
  }

  const isNote = (note) => {
    if (note === undefined || !note || note === null || note === " " || note === "undefined" || note === "null") {
      return false
    } else {
      return true
    }
  }
  
  return (
    <>
      <Container
        active={active}
        disabled={loading}
        isSelected={isSelected}
        onClick={() => handSelectedCustomer()}
        enabledSelection={selectedCustomer?.isOpen}
      >
        <Content>
          <Line onClick={(e) => handOpenChat(e)}>
            <Name>
              <span>{data.client_name}</span>
            </Name>
            <Date>
              <span>{maskDate(data.started_at) + ' - ' + moment(data.started_at).format('HH:mm')}</span>
            </Date>
          </Line>
          <Line>
            <div className='infoUser' onClick={(e) => handOpenChat(e)}>
              <Tag type='inFo'>
                {maskZero(data.id)}
              </Tag>
              <Tag type='inFo'>
                <span><BsHeadset /></span>
                <p>{data.nomecompleto}</p>
              </Tag>
            </div>
            <div className='icon-line'>
              {isNote(data.note) &&
                <Tag type='note'>
                  <IoAlertOutline className='iconNoteInline' onClick={() => handleOpenNote()} />
                </Tag>
              }
              <IconDown>
                <BiChevronDown onClick={(e) => handleOpenMenu(e)} />
              </IconDown>
              <IconDown>
                <BiTransfer onClick={() => handleOpenTransfer()} style={{ fontSize: '1.3rem' }} />
              </IconDown>
            </div>
          </Line>

          {data.type === 'VIDEOCHAMADA' &&
            <Line>
              <VideoCallStatus dataCall={data?.link} />
            </Line>
          }

          <Menu anchorEl={anchorEl} ref={refMenu}>
            <li onClick={() => handleOpenProfile()}>
              Ver Perfil
            </li>
            <li onClick={() => handleOpenTransfer()}>
              Transferir Atendimento
            </li>
            <li onClick={() => handleOpenHistoric()}>
              Histórico de Atendimento
            </li>
          </Menu>

          {profileOpen &&
            <ProfileClient client={data} isOpen={profileOpen} close={() => handleCloseProfile()} load={loadChats} />
          }
          <Modal title={titleTransfer()} isOpen={transferOpen} close={() => handleCloseTransfer()}>
            {transferOpen && <TransferClient customer={data} close={() => handleCloseTransfer()} />}
          </Modal>
          <Modal title={'Anotação'} isOpen={noteOpen} close={() => handleCloseNote()}>
            {noteOpen && <NoteClient idNote={data.id} />}
          </Modal>
          <Modal title={'Histórico de Atendimento'} isOpen={openHistoric} close={() => setOpenHistoric(!openHistoric)}>
            {openHistoric && <HistoricClient client={data} />}
          </Modal>
          <Modal title={'Atendimento em aberto'}
            isOpen={customerServiceOpenData ? true : false}
            close={
              () => setCustomerServiceOpenData(null)
            }
          >
            <ViewerCustomerServiceOpen
              customerServiceOpen={customerServiceOpenData}
              onClose={
                () => setCustomerServiceOpenData(null)
              }
            />
          </Modal>
        </Content>
      </Container>
      {loading && <Loading />}
    </>
  );
}